import axios from "axios"
import { captureException } from "@sentry/nextjs"

import { SELF_RECORDING_APP_URL } from "../requests"
import type { AppDispatch, RootState } from "../lib/store"
import type { Insight } from "@/types/self_recording_api/insight"
import type { Conversation } from "@/types/self_recording_api/conversation"

let isCurrentlyFetching: Promise<void> | null = null

const fetchInsightDetails = async (insights: Insight[]): Promise<Insight[]> => {
  return Promise.all(
    insights.map(async (insight) => {
      try {
        const { data } = await axios.get<Insight>(`${SELF_RECORDING_APP_URL}/insights/${insight.insightId}`)
        return data
      } catch (error) {
        captureException(error)
        return insight
      }
    }),
  )
}

export const fetchInsightsData = () => {
  return async (dispatch: AppDispatch, getState: () => RootState): Promise<void> => {
    const { insights, conversationsHistory } = getState()
    if (insights !== null && conversationsHistory !== null) {
      return
    }

    if (isCurrentlyFetching) {
      return isCurrentlyFetching
    }

    isCurrentlyFetching = (async () => {
      try {
        const { data: insights } = await axios.get<Insight[]>(`${SELF_RECORDING_APP_URL}/insights`)
        const { data: conversations } = await axios.get<Conversation[]>(`${SELF_RECORDING_APP_URL}/conversations`)

        const insightsDetails = await fetchInsightDetails(insights ?? [])

        dispatch({ type: "insights", payload: insightsDetails })
        dispatch({ type: "conversationsHistory", payload: conversations ?? [] })
      } catch (error) {
        console.error("Error fetching insights data:", error)
        captureException(error)
      } finally {
        isCurrentlyFetching = null
      }
    })()

    return isCurrentlyFetching
  }
}
